import * as React from "react"
import "./App.css"
import { BrowserRouter as Router, Route, Link, Redirect, Switch } from "react-router-dom"
import { useIdentity } from "./components/authn";
import { Jsonify } from "./components/formatting";

import { login, logout, getToken } from "./authn";



export function Home() {
  const identity = useIdentity("portal")
  return (
    <div>
      <h2>Home</h2>
      <div>Your id_token data: <Jsonify value={identity} /></div>
    </div>
  )
}

function Menu() {
  return (
    <ul>
      <li><Link to="/">Home</Link></li>
    </ul>
  )
}

function App() {
  const initial = useIdentity<{ [claim: string]: string }>("portal")
  return (
    <>
      {initial ? (
        <>
          <div className="container w-container">
            <div className="header-pic-div" />
            <div className="div-block">
              <h1 className="heading1">Welcome</h1>
              <h4 className="subheading">Reset Your Password Below</h4>
              <div className="div-block-child"><button className="button is-primary" style={{ margin: "auto" }} onClick={() => logout("b2c_portal", { force: true })}>Logout</button></div>
            </div>
            <a href="https://www.imagined.cloud">
              <div className="footer-pic-div"><img src="" alt="" className="image" /></div>
            </a>
            <div className="footer-link-div" />
          </div>
        </>
      ) : (
          <>
            <div className="container w-container">
              <div className="header-pic-div" />
              <div className="div-block">
                <h1 className="heading1">Welcome</h1>
                <h4 className="subheading">Reset Your Password Below</h4>
                <div className="div-block-child"><button className="button is-primary" style={{ margin: "auto" }} onClick={() => getToken("portal")}>Sign In</button></div>
              </div>
              <a href="https://www.imagined.cloud">
                <div className="footer-pic-div"><img src="" alt="" className="image" /></div>
              </a>
              <div className="footer-link-div" />
            </div>
          </>


        )}
    </>
  )
}

export default App
